import { h } from 'vue'
import AtomButton from '~/components/atoms/button/button.vue'
import UiComponentContainer from '~ui/components/container/container.vue'
import UiComponentHeading from '~ui/components/heading/heading.vue'
import UiComponentIcon from '~ui/components/icon/icon.vue'
import UiComponentImage from '~ui/components/image/image.vue'
import UiComponentParagraph from '~ui/components/paragraph/paragraph.vue'
import UiComponentWrapper from '~ui/components/wrapper/wrapper.vue'

const Functional = (props) => {
  const stories = props.record.stories
    .filter(story => !!story.keyNumbers && !!story.logo)
    .map(({ id, keyNumbers, logo }) => {
      const [title, ...otherOccurrences] = keyNumbers.split(' ')
      const text = otherOccurrences.join(' ')
      return {
        id,
        logo,
        title,
        text,
      }
    })

  if (stories.length === 0) {
    return
  }

  return h(
    UiComponentContainer,
    {
      class: 'customer-stories',
      end: 1,
      start: 1,
    },
    () => [
      h(UiComponentHeading, { level: 2 }, () => props.record.title),
      h(UiComponentWrapper, { class: 'inner' }, () => [
        h(UiComponentImage, {
          alt: 'illustration',
          class: 'illustration',
          expectedSize: 151,
          height: 696,
          orientation: 'portrait',
          source:
            'https://livestorm.imgix.net/1127/1684224623-illustration.png',
          width: 453,
        }),
        h(UiComponentWrapper, { class: 'list' }, () => [
          stories.map(({ id, logo, title, text }) =>
            h(
              UiComponentWrapper,
              {
                key: `customer-story-${id}`,
                class: 'item',
              },
              () => [
                h(UiComponentParagraph, { class: 'title' }, () => title),
                h(UiComponentParagraph, { class: 'text' }, () => text),
                h(UiComponentImage, {
                  alt: logo.alt,
                  class: 'logo',
                  expectedSize: 16,
                  extraParams: {
                    trim: 'color',
                  },
                  height: logo.height,
                  orientation:
                    logo.width >= logo.height ? 'portrait' : 'landscape',
                  source: logo.url,
                  useNaturalHeight: true,
                  useNaturalWidth: true,
                  width: logo.width,
                }),
              ],
            ),
          ),
        ]),
      ]),
      h(UiComponentWrapper, { class: 'action' }, () => [
        h(
          AtomButton,
          { to: props.to, type: 'text' },
          () => [
            props.global.readTheirStories,
            h(UiComponentIcon, { type: 'arrow-right' }),
          ],
        ),
      ]),
    ],
  )
}

Functional.props = {
  global: {
    required: true,
    type: Object,
  },
  record: {
    required: true,
    type: Object,
  },
  to: {
    required: true,
    type: String,
  },
}

export default Functional
